// @flow

import Select from './AutoSelect'

export default Select
